import lodash from 'lodash';
import { CustomerInfoType, HomeAddressTypeEnum } from 'types/customer';
import { getChnHomeAddressFields } from './ChnHomeAddress';
import { getCommon2HomeAddressFields } from './Common2HomeAddress';
import { getCommonHomeAddressFields } from './CommonHomeAddress';
import { getUsaHomeAddressFields } from './UsaHomeAddress';

export const getHomeAddressFields = (homeAddressType: HomeAddressTypeEnum, needHomeAddressType: boolean = true) => {
    switch (homeAddressType) {
        case HomeAddressTypeEnum.CHN:
            return getChnHomeAddressFields(needHomeAddressType);
        case HomeAddressTypeEnum.USA:
            return getUsaHomeAddressFields(needHomeAddressType);
        case HomeAddressTypeEnum.COMMON:
            return getCommonHomeAddressFields(needHomeAddressType);
        case HomeAddressTypeEnum.COMMON2:
            return getCommon2HomeAddressFields(needHomeAddressType);
        default:
            const _checkNever: never = homeAddressType;

            return [];
    }
};

/**
 * @description 获取在w8展示的详细地址(非home_detail), 会根据用户的地址类型对字段进行拼接
 */
export function getAddressDetail(addressData: CustomerInfoType) {
    const fields = getHomeAddressFields(addressData.home_address_type, false).filter(
        item => !['home_postal', 'same_delivery_and_residence', 'has_delivery_address'].includes(item)
    );

    return Object.values(lodash.pick(addressData, fields)).filter(Boolean).join(' ');
}

/**
 *  @description 根据SSN和居住国获取地址类型
 */
export function getAddressTypeByResCountry(isSSN: boolean, legalResidenceCountry?: string): HomeAddressTypeEnum {
    if (isSSN) {
        return HomeAddressTypeEnum.USA;
    }

    if (legalResidenceCountry === 'CHN') {
        return HomeAddressTypeEnum.CHN;
    }

    if (legalResidenceCountry === 'CAN') {
        // 非SSN加拿大使用COMMON2地址类型：https://tigertech.feishu.cn/wiki/UfEKwz1gviZMaqkkZG6cORyvn2e
        return HomeAddressTypeEnum.COMMON2;
    }

    return HomeAddressTypeEnum.COMMON;
}
